export default "__VITE_PUBLIC_ASSET__944eaa2f__"